<template>
  <b-container id="maindiv">
    <section>
      <b-row>
        <div class="col-md-12">
          <h2>{{$lang('timesheet')}}</h2>
          <!-- <p class="my-3">{{$lang('description')}}</p> -->
        </div>
      </b-row>
    </section>

    <section id="mainsection">
      <div id="content">
        <div v-if="wait" class="text-center text-muted my-5">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
        <div v-if="error" class="text-center text-muted my-2">
          <b-alert show variant="danger">{{error}}</b-alert>
        </div>

        <b-row v-if="loaded">
          <div class="col-md-9">
            <div class="formgroup">
              <p class="text-uppercase text-muted sectionhdr">{{$lang('details')}}</p>
              <b-list-group class="ml-1">
                <b-list-group-item class="d-flex justify-content-between align-items-center first-inverted">
                  {{$lang('week')}}
                  <span class="font-weight-bold">{{doc.data.weekdd}}</span>
                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  {{$lang('firma')}}
                  <span class="ml-3 font-weight-bold">{{doc.data.zeitarbeitfirma}}</span>
                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  {{$lang('remark')}}
                  <span class="ml-3 font-weight-bold">{{doc.data.remark}}</span>
                  <b-button v-if="canEdit" variant="light" @click="editRemark()"><i class="fa fa-edit"></i></b-button>
                </b-list-group-item>
              </b-list-group>
            </div>
            <div class="formgroup">
              <p class="text-uppercase text-muted sectionhdr">{{$lang('days')}}</p>
              <b-list-group class="ml-1">
                <b-list-group-item class="d-flex justify-content-between align-items-center first-inverted">
                  <span></span>
                  <div class="datepair">
                    <span>{{$lang('columnhours')}}</span>
                    <span>{{$lang('columnpause')}}</span>
                    <span v-if="canEdit"></span>
                  </div>
                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  {{$lang('d1')}}
                  <div class="datepair">
                  <span class="font-weight-bold">{{doc.data.d1_len}}</span>
                  <span class="font-weight-bold">{{doc.data.d1_pause}}</span>
                  <b-button v-if="canEditDay(1)" variant="light" @click="editDay(1)"><i class="fa fa-edit"></i></b-button>
                  </div>
                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  {{$lang('d2')}}
                  <div class="datepair">
                  <span class="font-weight-bold">{{doc.data.d2_len}}</span>
                  <span class="font-weight-bold">{{doc.data.d2_pause}}</span>
                  <b-button v-if="canEditDay(2)" variant="light" @click="editDay(2)"><i class="fa fa-edit"></i></b-button>
                  </div>
                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  {{$lang('d3')}}
                  <div class="datepair">
                  <span class="font-weight-bold">{{doc.data.d3_len}}</span>
                  <span class="font-weight-bold">{{doc.data.d3_pause}}</span>
                  <b-button v-if="canEditDay(3)" variant="light" @click="editDay(3)"><i class="fa fa-edit"></i></b-button>
                  </div>
                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  {{$lang('d4')}}
                  <div class="datepair">
                  <span class="font-weight-bold">{{doc.data.d4_len}}</span>
                  <span class="font-weight-bold">{{doc.data.d4_pause}}</span>
                  <b-button v-if="canEditDay(4)" variant="light" @click="editDay(4)"><i class="fa fa-edit"></i></b-button>
                  </div>
                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  {{$lang('d5')}}
                  <div class="datepair">
                  <span class="font-weight-bold">{{doc.data.d5_len}}</span>
                  <span class="font-weight-bold">{{doc.data.d5_pause}}</span>
                  <b-button v-if="canEditDay(5)" variant="light" @click="editDay(5)"><i class="fa fa-edit"></i></b-button>
                  </div>
                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  {{$lang('d6')}}
                  <div class="datepair">
                  <span class="font-weight-bold">{{doc.data.d6_len}}</span>
                  <span class="font-weight-bold">{{doc.data.d6_pause}}</span>
                  <b-button v-if="canEditDay(6)" variant="light" @click="editDay(6)"><i class="fa fa-edit"></i></b-button>
                  </div>
                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  {{$lang('d7')}}
                  <div class="datepair">
                  <span class="font-weight-bold">{{doc.data.d7_len}}</span>
                  <span class="font-weight-bold">{{doc.data.d7_pause}}</span>
                  <b-button v-if="canEditDay(7)" variant="light" @click="editDay(7)"><i class="fa fa-edit"></i></b-button>
                  </div>
                </b-list-group-item>
              </b-list-group>
              <div class="d-flex justify-content-end font-weight-bold p-3">
                <span class="mr-2">{{$lang('totalinweek')}}</span>
                <div class="datepair">
                  <span>{{doc.data.len_total}}</span>
                  <span></span>
                  <span v-if="canEdit"></span>
                </div>
              </div>
            </div>
            <div class="formgroup">
              <p class="text-uppercase text-muted sectionhdr">{{$lang('dochistory')}}</p>
              <ul class="timeline">
                  <li class="media" v-for="one in doc.history" v-bind:key="one.id" v-bind:style="{'border-color': one.s_sclr}">
                    <div class="media-body">
                      <h6 class="font-weight-bold">{{one.state}}</h6>
                      <span>{{one.dd}}</span>
                      <span class="ml-3" >{{one.username}}</span>
                      <p class="mt-1">{{one.remark}}</p>
                    </div>
                  </li>
              </ul>
            </div>
          </div>
          <div class="col-md-3">

            <div v-if="hasActions" class="formgroup">
              <p class="text-uppercase text-muted sectionhdr">{{$lang('actions')}}</p>
              <b-button class="mb-3 mr-3 actionbutton" v-for="one in doc.actions" v-bind:key="one.oid" @click="doAction(one)" :variant="one.variant">
                <span class="m-1">{{one.caption}}</span>
                <i class="fa ml-2 p-1" v-bind:class="one.icon"></i>
              </b-button>
            </div>
            
            <div class="formgroup">
              <p class="text-uppercase text-muted sectionhdr">{{$lang('info')}}</p>
              <ul class="list-unstyled font-weight-light">
                  <li>{{$lang('s_cdt')}} {{doc.info.s_cdt}}</li>
                  <li>{{$lang('s_cr')}} {{doc.info.s_cr}}</li>
                  <li v-if="doc.info.s_mdt">{{$lang('s_mdt')}} {{doc.info.s_mdt}}</li>
                  <li v-if="doc.info.s_mr">{{$lang('s_mr')}} {{doc.info.s_mr}}</li>
              </ul>
            </div>

          </div>
        </b-row>
      </div>
    </section>

    <b-modal no-close-on-backdrop id="modal-14day" :title="editday.caption" @ok.prevent="editDayOk" :ok-title="$lang('ok')" :cancel-title="$lang('cancel')">
      <b-form>
        <b-form-group :label="$lang('from')">        
          <b-form-input v-model="editday.timestart" type='time'></b-form-input>
        </b-form-group>
        <b-form-group :label="$lang('to')">        
          <b-form-input v-model="editday.timeend" type='time'></b-form-input>
        </b-form-group>
        <b-form-group :label="$lang('pause')">        
          <b-form-select class="w-auto" v-model="editday.pausehh" :options='select_hh'></b-form-select>
          <span class='p-1'>{{$lang('hours')}}</span>
          <b-form-select class="w-auto" v-model="editday.pausemm" :options='select_mm'></b-form-select>
          <span class='p-1'>{{$lang('minutes')}}</span>
        </b-form-group>
        <b-form-group :label="$lang('reference')">        
          <b-alert show variant="info">{{editday.reference}}</b-alert>  
        </b-form-group>
        <b-alert v-if="modalerror" show variant="danger">{{modalerror}}</b-alert>
        <div v-if="modalwait" class="d-flex mt-1">
          <b-spinner variant="primary"></b-spinner>
          <span class="ml-3 mt-1">{{$lang('saving')}}</span>
        </div>
      </b-form>
    </b-modal>

    <b-modal no-close-on-backdrop id="modal-14remark" :title="$lang('edit')" @ok.prevent="editRemarkOk" :ok-title="$lang('ok')" :cancel-title="$lang('cancel')">
      <b-form>
        <b-form-group :label="$lang('remark')">
          <b-form-textarea v-model="editremark"></b-form-textarea>
        </b-form-group>  
        <b-alert v-if="modalerror" show variant="danger">{{modalerror}}</b-alert>
        <div v-if="modalwait" class="d-flex mt-1">
            <b-spinner variant="primary"></b-spinner>
            <span class="ml-3 mt-1">{{$lang('saving')}}</span>
        </div>
     </b-form>
    </b-modal>

  </b-container>
</template>

<script>
import axios from "axios";
export default {
  created() {
    this.openDocument();
    this.select_hh = [];
    for (var i=0; i<9; i++) {
      this.select_hh.push(i);
    };
    this.select_mm = [];
    for (var i=0; i<61; i++) {
      this.select_mm.push(i);
    };
  },
  data() {
    return {
      id: null,
      wait: true,
      error: null,
      loaded: null,
      doc: {},
      editday: {weekday: 0, timestart:  null, timeend: null, caption: "Day", pausehh:0, pausemm:0, reference: null},
      editremark: null,
      modalerror: null,
      modalwait: null,
      select_hh: [],
      select_mm: [],
    };
  },
  computed: {
      canEdit: function() {
        return this.doc.data.s_s === 1 || this.doc.data.s_s === 2130019;
      },
      hasActions: function() {
        return this.doc.actions.length > 0;
      },
  },
  methods: {
    openDocument() {
      this.id = this.$route.params.id;
      this.readData();
    },
    readData(){
      this.wait = true;
      axios.get("/api/GetTimesheet?id=" + this.id)
        .then(resp => {
          this.wait = null;
          this.doc = resp.data.doc;
          this.loaded = true;
        })
        .catch(error => {
          this.wait = null;
          this.error = error.message;
          if (error.response.data.message) {
            this.error = error.response.data.message;
          }
        });
    },
    canEditDay(dayN){
       if (this.doc.data.s_s != 1 && this.doc.data.s_s != 2130019) {
         return false;
       }
       var dd = 'd'+dayN;
       if (this.doc.data[dd+"_disable"] === 1) {
         return false;
       }
       return true;
    },
    editDay(dayN){
      this.modalerror = null;
      this.modalwait = null;
      var dd = 'd'+dayN;
      this.editday.weekday = dayN;
      this.editday.caption = this.$lang(dd);
      this.editday.timestart = this.doc.data[dd+"_start"];
      this.editday.timeend = this.doc.data[dd+"_end"];
      this.editday.pausehh = this.doc.data[dd+"_pausehh"];
      this.editday.pausemm = this.doc.data[dd+"_pausemm"];
      this.editday.reference = this.doc.data[dd+"_ref"];
      this.$bvModal.show("modal-14day");
    },
    editRemark(){
      this.modalerror = null;
      this.modalwait = null;
      this.editremark = this.doc.data.remark;
      this.$bvModal.show("modal-14remark");
    },
    async editRemarkOk(evt) {
      this.modalerror = null;
      this.modalwait = true;
      let form = evt.vueTarget.$refs.body.firstChild
      if (!form.checkValidity()){
         form.classList.add('was-validated');
         this.modalwait = null
         return;
      };
      var data2save = {
        id: this.id,
        remark: this.editremark,
      }
      axios.post('/api/PostOperationData?contextoid=2130013&method=change_remark', data2save) 
        .then(answ => {
          this.$bvModal.hide("modal-14remark");
          this.doc.data.remark = this.editremark;
        })
        .catch(error => {
          this.modalwait = null;
          this.modalerror = error.message;
          if (error.response.data.message) {
             this.modalerror = error.response.data.message;
          }
        });
    },
    async editDayOk(evt) {
      this.modalerror = null;
      this.modalwait = true;
      let form = evt.vueTarget.$refs.body.firstChild
      if (!form.checkValidity()){
         form.classList.add('was-validated');
         this.modalwait = null
         return;
      };
      this.editday.id = this.id;
      axios.post('/api/PostOperationData?contextoid=2130013&method=change_day', this.editday) 
        .then(answ => {
          this.$bvModal.hide("modal-14day");
          this.readData();
        })
        .catch(error => {
          this.modalwait = null;
          this.modalerror = error.message;
          if (error.response.data.message) {
             this.modalerror = error.response.data.message;
          }
        });
    },
    doAction(action) {
      this.$bvModal.msgBoxConfirm('Are you sure you want to execute "'+action.caption+'"?')
          .then(value => {
            if (value === true) {
               this.execAction(action);
            }
          })
    },
    execAction(action) {
        let actionRequest = {docid: this.id, oid:  action.oid};
        axios.post('/api/DoActionTimesheet', actionRequest) 
        .then(answ => {
          this.$bvToast.toast(answ.data.message, {title: action.caption, variant: "success"});
          this.$router.push("/timesheets")
        })
        .catch(error => {
          let actionerror = error.message;
          if (error.response && error.response.data.message) {
             actionerror = error.response.data.message;
          }
          this.$bvToast.toast(actionerror, {title: "Error", variant: "danger"});
        });        
    },

  },
  locales: {
    en: {
      timesheet: "Time Sheet",
      details: "Details",
      actions: "Actions",
      dochistory: "Document History",
      info: "Document Information",
      columnhours: "Hours",
      columnpause: "Pause",
      ok: "OK",
      cancel: "Cancel",
      edit: "Edit",
      remark: "Remark:",
      s_cdt: "Created:",
      s_cr: "Created by:",
      s_mdt: "Modified:",
      s_mr: "Modified by:",
      week: "Week:",
      days: "Week days",
      firma: "Agency:",
      d1: "Monday:",
      d2: "Tuesday:",
      d3: "Wednesday:",
      d4: "Thursday:",
      d5: "Friday:",
      d6: "Saturday:",
      d7: "Sunday:",
      totalinweek: "Total hours:",
      minutes: "minutes",
      hours: "hours ",
      pause: "Pause:",
      reference: "Reference:",
      from: "Time from:" ,
      to: "Time to:",
    },
    de: {
      timesheet: "Stundennachweis",
      details: "Einzelheiten",
      actions: "Aktionen",
      dochistory: "Dokumentenverlauf",
      info: "Dokumentinformationen",
      columnhours: "Arbeitszeit",
      columnpause: "Pause",
      remark: "Bemerkungen:",
      ok: "OK",
      cancel: "Abbrechen",
      edit: "Bearbeiten",
      s_cdt: "Erstellt:",
      s_cr: "Erstellt von:",
      s_mdt: "Geändert:",
      s_mr: "Geändert von:",
      week: "Woche:",
      days: "Tags",
      firma: "Zeitarbeitfirma:",
      d1: "Montag",
      d2: "Dienstag",
      d3: "Mittwoch",
      d4: "Donnerstag",
      d5: "Freitag",
      d6: "Samstag",
      d7: "Sonntag",
      totalinweek: "Gesamtstunden:",
      minutes: "Minutes",
      hours: "Std ",
      pause: "Pause:",
      reference: "Referenz:",
      from: "Zeit von:" ,
      to: "Zeit bis:",
    },
    ru:  {
      timesheet: "Отчет о рабочем времени",
      details: "Подробно",
      actions: "Действия",
      dochistory: "История обработки",
      info: "Информация о документе",
      columnhours: "Рабочие часы",
      columnpause: "Паузы",
      ok: "OK",
      cancel: "Отмена",
      edit: "Редактирование",
      remark: "Примечания:", 
      s_cdt: "Создан:",
      s_cr: "Кем создан:",
      s_mdt: "Изменен:",
      s_mr: "Кем изменен:",
      week: "Неделя:",
      days: "Дни недели",
      firma: "Агенство:",
      d1: "Понедельник:",
      d2: "Вторник:",
      d3: "Среда:",
      d4: "Четверг:",
      d5: "Пятница:",
      d6: "Суббота:",
      d7: "Воскресенье:",
      totalinweek: "Всего рабочих часов:",
      minutes: "минут",
      hours: "часов ",
      pause: "Время перерывов:",
      reference: "Справочно:",
      from: "Время с:" ,
      to: "Время по:",
    },
    pl:  {
      timesheet: "Raport czasowy",
      details: "Detale",
      actions: "Działania",
      dochistory: "Historia przetwarzania",
      info: "Informacje o dokumencie",
      columnhours: "Godziny pracy",
      columnpause: "Pauzuje",
      ok: "OK",
      cancel: "Anulować",
      edit: "Redagowanie",
      remark: "Uwagi:", 
      s_cdt: "Stworzone:",
      s_cr: "Stworzone przez:",
      s_mdt: "Zmodyfikowany:",
      s_mr: "Modyfikowane przezda:",
      week: "Tydzień:",
      days: "Dni tygodnia",
      firma: "Agencja:",
      d1: "Poniedziałek",
      d2: "Wtorek",
      d3: "Środa",
      d4: "Czwartek",
      d5: "Piątek",
      d6: "Sobota",
      d7: "Niedziela",
      totalinweek: "Łączny czas pracy:",
      minutes: "minuty",
      hours: "godziny ",
      pause: "Czasy przerw:",
      reference: "Na przykład:",
      from: "Czas od:" ,
      to: "Czas do:",
    }    
  },
};
</script>

<style>
.sectionhdr {
  margin-bottom: 2rem;
  font-size: 12px;
  font-weight: 600;
}
.formgroup {
  padding: 24px 0;
  background-color: #fff;
  min-height: 200px;
}
.toolbox {
  background-color: #fafafa;
  min-height: 350px;
}
ul.timeline {
    list-style-type: none;
    position: relative;
}
ul.timeline:before {
    content: ' ';
    background: #d4d9df;
    display: inline-block;
    position: absolute;
    left: 29px;
    width: 2px;
    height: 100%;
    z-index: 400;
}
ul.timeline > li {
    margin: 20px 0;
    padding-left: 20px;
}
ul.timeline > li:before {
    content: ' ';
    background: white;
    display: inline-block;
    position: absolute;
    border-radius: 50%;
    border: 3px solid ;
    border-color: inherit;
    left: 20px;
    width: 20px;
    height: 20px;
    z-index: 400;
}
.state {
  white-space: nowrap;
} 
.first-inverted{
  background-color: #606b75;
  color: white;
  font-weight: bold;
}
thead.thead-dark{
  border: 1px solid #606b75;
}
.datepair{
    width: 45%;
    min-width: 180px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}
.datepair span{
    margin-left: 5px;
    min-width: 40px;
} 
.datepair button{
    margin-left: 5px;
} 
.actionbutton{
  min-width: 150px;
}
</style>



// WEBPACK FOOTER //
// src/EditTimesheetItem.vue